import MainContent from 'src/_components/HomePage/MainContent';
import HomePageLayout from 'src/_layout/HomePageLayout';

const Index = () => {
  return <MainContent />;
};
export default Index;

Index.getLayout = function getLayout(page) {
  return <HomePageLayout>{page}</HomePageLayout>;
};

Index.getInitialProps = () => {
  return {
    metadata: {
      className: 'DevSiteHomePageMetadata',
    },
  };
};
